import SectionWithSlider from "@components/global/SectionWithSlider"
import ProductsServicesConcession from "@components/pages/products-services/products-services-concession"
import ProductsServicesCover from "@components/pages/products-services/products-services-cover"
import ProductsServicesMore from "@components/pages/products-services/products-services-more"
import ProductsServicesMtix from "@components/pages/products-services/products-services-mtix"
import { getPageBySlug, getPostCategoriesByType } from "lib/api"
import { extractMeta } from "src/mixins"

function ProductsServicesPage({ data, locale, cinema, concessions }) {
  const pageData = data?.meta
  const cover = { ...extractMeta(pageData, "cinema"), cinema }
  const concessionSection = {
    ...extractMeta(pageData, "concessions"),
    concessions,
  }
  const services = extractMeta(pageData, "services")
  const mtix = extractMeta(pageData, "m_tix")
  return (
    <>
      <ProductsServicesCover data={cover} locale={locale} />
      <ProductsServicesConcession data={concessionSection} locale={locale} />
      <ProductsServicesMtix data={mtix} locale={locale} />
      <ProductsServicesMore data={services} locale={locale} />
    </>
  )
}
export default ProductsServicesPage

export async function getStaticProps(ctx) {
  const { locale } = ctx
  const data = await getPageBySlug("products")
  const cinema = await getPostCategoriesByType("CINEMA")
  const concessions = await getPostCategoriesByType("CONCESSION")
  return {
    props: {
      seo: {
        title: "Product & Services",
      },
      page: "product-services",
      locale,
      data,
      cinema,
      concessions,
    },
    revalidate: 60,
  }
}
